import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

interface LeaveConfirmProps {
  open: boolean
  onStay: () => void
  onLeave: () => void
}

/** In-page confirm for leaving with a recording that was never sent. */
const LeaveConfirm: React.FC<LeaveConfirmProps> = ({ open, onStay, onLeave }) => {
  const { t } = useTranslation('writeSpeak')
  const stayRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (!open) return
    stayRef.current?.focus()
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onStay()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open])

  if (!open) return null
  return (
    <div className='ws-step ws-confirm-scrim' onMouseDown={(e) => e.target === e.currentTarget && onStay()}>
      <div className='ws-confirm' role='alertdialog' aria-modal='true' aria-labelledby='ws-confirm-title'>
        <h4 id='ws-confirm-title'>{t('leave.title')}</h4>
        <p>{t('leave.body')}</p>
        <div className='ws-confirm-acts'>
          <button type='button' className='ws-link' onClick={onLeave}>
            {t('leave.leave')}
          </button>
          <button type='button' className='ws-btn' onClick={onStay} ref={stayRef}>
            {t('leave.stay')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default LeaveConfirm
